import config from "../../../_config/config";
import axiosInstance from "../../../_helpers/axiosInstance";
import { sharedBucketlistConstants } from "../../_constants/hiringManager/bucketlist.constants";

//get shared bucket list
export const get_bucket_list_by_mentor_data_action = () => async (dispatch) => {
    dispatch({
      type: sharedBucketlistConstants.GET_BUCKET_LIST_BY_MENTOR_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(config.hiringManager.getAllSharedBucketList);
      if (response.status) {
        dispatch({
          type: sharedBucketlistConstants.GET_BUCKET_LIST_BY_MENTOR_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: sharedBucketlistConstants.GET_BUCKET_LIST_BY_MENTOR_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };